import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter as Router } from 'react-router-dom';
import { ThemeProvider } from '@emotion/react';

import { initSentry } from './config/sentry';
import ErrorBoundary from './components/ErrorBoundary';
import FallbackComponent from './components/FallbackComponent';
import theme from './styles/theme';
import App from './App';

// Import Inter font
import '@fontsource/prata/400.css';
import '@fontsource/questrial/400.css';

// Initialize Sentry
initSentry();

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <ErrorBoundary FallbackComponent={FallbackComponent}>
      <HelmetProvider>
        <ThemeProvider theme={theme}>
          <Router>
            <App />
          </Router>
        </ThemeProvider>
      </HelmetProvider>
    </ErrorBoundary>
  </React.StrictMode>,
);

// Log the environment for debugging
// eslint-disable-next-line no-console
console.log(`Running in ${process.env.NODE_ENV} mode`);
